import { render, staticRenderFns } from "./ImageOutlineProperties.vue?vue&type=template&id=b3da1004&scoped=true"
import script from "./ImageOutlineProperties.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageOutlineProperties.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ImageOutlineProperties.vue?vue&type=style&index=0&id=b3da1004&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3da1004",
  null
  
)

export default component.exports